import axios from 'axios';
import { trackFBEvent } from '../components/CookieConsent';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Get UTM parameters from URL
export const getUTMParams = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    utm_source: params.get('utm_source') || '',
    utm_campaign: params.get('utm_campaign') || '',
    utm_medium: params.get('utm_medium') || '',
    utm_content: params.get('utm_content') || '',
    utm_term: params.get('utm_term') || ''
  };
};

// Submit AI Agency Lead
export const submitAIAgencyLead = async (data) => {
  const response = await axios.post(`${API}/leads/ai-agency`, {
    name: data.name,
    email: data.email,
    phone: data.phone
  });
  trackFBEvent('Lead', { content_name: 'AI Agency', content_category: 'ai-agency' });
  return response.data;
};

// Submit Partner Track Lead
export const submitPartnerLead = async (data) => {
  const utmParams = getUTMParams();
  const response = await axios.post(`${API}/leads/partner-track`, {
    fullName: data.fullName,
    phone: data.phone,
    email: data.email,
    objective: data.objective || '',
    experience: data.experience || '',
    budget: data.budget || '',
    ...utmParams
  });
  trackFBEvent('Lead', { content_name: 'Partner Track', content_category: 'partner-track' });
  return response.data;
};

// Submit OPM Lead
export const submitOPMLead = async (data) => {
  const utmParams = getUTMParams();
  const response = await axios.post(`${API}/leads/opm`, {
    fullName: data.fullName,
    role: data.role || '',
    companyName: data.companyName,
    website: data.website || '',
    revenue: data.revenue,
    phone: data.phone,
    email: data.email,
    challenge: data.challenge || '',
    ...utmParams
  });
  trackFBEvent('Lead', { content_name: 'OPM', content_category: 'opm' });
  return response.data;
};

// Submit Contact Form Lead
export const submitContactLead = async (data) => {
  const response = await axios.post(`${API}/leads/contact`, {
    name: data.name,
    email: data.email,
    phone: data.phone,
    subject: data.subject,
    message: data.message || ''
  });
  trackFBEvent('Lead', { content_name: 'Contact', content_category: 'contact' });
  return response.data;
};

// Submit Executives Lead
export const submitExecutivesLead = async (data) => {
  const response = await axios.post(`${API}/leads/executives`, data);
  trackFBEvent('Lead', { content_name: 'Executives', content_category: 'executives' });
  return response.data;
};

// Submit Affiliate Club Lead
export const submitAffiliateClubLead = async (data) => {
  const response = await axios.post(`${API}/leads/affiliate-club`, data);
  trackFBEvent('Lead', { content_name: 'Affiliate Club', content_category: 'affiliate-club' });
  return response.data;
};

// Submit Merchant Lead
export const submitMerchantLead = async (data) => {
  const response = await axios.post(`${API}/leads/merchant`, data);
  trackFBEvent('Lead', { content_name: 'Merchant', content_category: 'merchants' });
  return response.data;
};

// Generic Submit Lead function for different sources
export const submitLead = async (data, source) => {
  const utmParams = getUTMParams();
  const response = await axios.post(`${API}/leads/${source}`, {
    ...data,
    ...utmParams
  });
  trackFBEvent('Lead', { content_name: source, content_category: source });
  return response.data;
};
